import React from 'react'

import { useTab } from '../hooks'

import styles from './Tabs.module.css'

const HiddenTab = ({ path, label, icon }) => {
  const [isSelected, select] = useTab(path)

  if (!isSelected) return null
  return (
    <li className={styles.tabSelected} onClick={select}>
      {icon && <i className={icon}></i>}
      {label && <div className={styles.tabLabel}>{label}</div>}
    </li>
  )
}
export default HiddenTab
